
import { mapState } from 'vuex';
import ResultItem from '@/components/resultItem.vue';
import Slider from '@/components/ui/slider.vue';

export default {
  name: 'ResultGroup',

  components: {
    ResultItem,
    Slider,
  },

  props: {
    postType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      page: 1,
      perPage: 10,
      loading: false,
      totalPages: 0,
      searchResults: [],
      startIndex: 0,
    };
  },

  computed: {
    ...mapState(['categories']),

    query() {
      return this.$route.query.q;
    },

    cat() {
      return this.$route.query.cat;
    },

    category() {
      return this.cat
        ? this.categories.find((c) => c.id === parseInt(this.cat))
        : null;
    },
  },

  watch: {
    query() {
      this.newSearch();
    },
  },

  mounted() {
    this.newSearch();
  },

  methods: {
    checkIfEndReached(payload) {
      if (
        payload.active &&
        payload.active >= this.searchResults.length - payload.perView
      ) {
        this.search(payload.active);
      }
    },

    newSearch() {
      if (!this.query) {
        this.$router.push(this.localePath({ name: 'slug' }));
      } else {
        this.page = 1;
        this.searchResults = [];
        this.totalPages = 0;
        this.search(0);
      }
    },

    async search(startIndexForSlider) {
      if (this.cat) {
        return this.searchProducts(startIndexForSlider);
      }
      this.loading = true;
      const { data, headers } = await this.$wp.search({
        perPage: this.perPage,
        page: this.page,
        search: this.query,
        postType: [this.postType],
      });
      this.loading = false;
      if (data && data.length) {
        this.searchResults = [...this.searchResults, ...data];
        this.startIndex = startIndexForSlider;
        this.page++;
        this.totalPages = parseInt(headers['x-wp-totalpages']);
      }
    },

    async searchProducts(startIndexForSlider) {
      this.loading = true;
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        category: this.cat,
        search: this.query,
      });
      this.loading = false;
      if (data && data.length) {
        const results = data.map((product) => ({
          id: product.id,
          type: 'post',
          subtype: 'product',
          url: `/product/${product.slug}`,
          title: product.name,
        }));
        this.searchResults = [...this.searchResults, ...results];
        this.startIndex = startIndexForSlider;
        this.page++;
        this.totalPages = parseInt(headers['x-wp-totalpages']);
      }
    },
  },
};
